import DREMainPage from "../../../../components/Financial/DRE/DREMainPage";

const DREClub = () => (
  <DREMainPage title="DRE Clube" endpoint="/club/dre" isClub />
);

export default DREClub;
